import React, { useState, useRef, useEffect } from 'react';

const useIntersectionObserver = (updateWhenIsNotIntersecting = false) => {
  const [entry, update] = useState(null);
  // {} as any
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => (mounted.current = false);
  }, []);

  return {
    entry,
    init(entries, options) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            update(entry);
          }
          if (updateWhenIsNotIntersecting && entry && !entry.isIntersecting) {
            mounted.current && update(entry);
          }
        });
      }, options);
      //
      try {
        entries.forEach(entry => io.observe(entry));
      } catch (err) {
        console.warn(entries);
      }
    },
  };
};

export default useIntersectionObserver;
